import { Component, OnInit } from '@angular/core';
import { ResourcesProvider } from '../../providers/resources/resources.provider';
import { Training } from '../../models/training';
import { ResourcesCssService } from '../resources/resources-css.service'
import { WindowService } from '../../services/window.service'
import { Base } from '../../models/base-model'
import { Resources } from 'src/app/models/resources';

@Component({
  selector: 'app-trainings',
  templateUrl: './trainings.page.html',
  styleUrls: ['./trainings.page.scss'],
})
export class TrainingsPage implements OnInit {

  trainings: Training[] = []

  sidebarContent: string = '';

  constructor(private resourcesProvider: ResourcesProvider,
              public resourcesCssService: ResourcesCssService,
              private windowService: WindowService) { }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) =>  this.resourcesCssService.width = value)

    this.resourcesProvider.getResources().subscribe(resources => {
      this.trainings = resources.trainings;
      this.resourcesUpdated(resources);
    })
  }

  gotoFacebook() {
    window.open('https://www.facebook.com/groups/1525195257704280/', '_blank');
  }

  trackByUuid(index: number, training: Training): string {
    return training.uuid
  }

  resourcesUpdated(resources: Resources): void {
    const callout = resources.findCallout('trainings-workshops-sidebar');
    this.sidebarContent = callout?.content || '';
  }
}
